import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { softwares } from '@/mocks/softwares';

export default function SiteSidebar() {
  const location = useLocation();

  const countOf = (categoryId: string) =>
    softwares.filter((s) => s.categoryId === categoryId).length;

  const isAllActive = location.pathname === '/softwares' && !location.search;

  return (
    <aside className="hidden lg:block w-64 shrink-0">
      <div className="sticky top-20 flex flex-col gap-4">
        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="px-4 py-3 bg-secondary-950 text-background-50">
            <h2 className="font-heading text-sm font-semibold flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                <i className="ri-apps-2-line text-base" />
              </span>
              软件分类导航
            </h2>
          </div>
          <nav className="p-2 flex flex-col">
            <Link
              to="/softwares"
              className={`px-3 py-2.5 rounded-md text-sm flex items-center justify-between cursor-pointer transition-colors ${
                isAllActive
                  ? 'bg-primary-100 text-primary-900 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-grid-line text-base" />
                </span>
                全部软件
              </span>
              <span className="text-xs text-foreground-500">{softwares.length}</span>
            </Link>
            {categories.map((cat) => {
              const active = location.pathname === `/category/${cat.id}`;
              return (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className={`px-3 py-2.5 rounded-md text-sm flex items-center justify-between cursor-pointer transition-colors ${
                    active
                      ? 'bg-primary-100 text-primary-900 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <span className="flex items-center gap-2.5">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                      <i className={`${cat.icon} text-base`} />
                    </span>
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500">{countOf(cat.id)}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="rounded-lg border border-background-200 bg-secondary-950 p-4 text-background-50">
          <h3 className="font-heading text-sm font-semibold text-primary-400">
            下载安全说明
          </h3>
          <p className="mt-2 text-xs leading-relaxed text-background-300">
            本站软件均为演示收录，下载链接为示范地址。请以软件官方网站发布的版本为准，谨慎核对来源后再安装。
          </p>
        </div>
      </div>
    </aside>
  );
}